import React from 'react'
import { useLocation } from 'react-router-dom'
import Navebar from './Navebar'
import Footer from './Footer2'
import { InstaPassAIChatProvider } from '../Home/InstaPassAIChatContext'
import { ProfileSidebarProvider } from '../UserProfile/ProfileSidebarContext'
import InstaPassAIFloatingChat from '../Home/InstaPassAIFloatingChat'

const LayoutIndex = ({children}) => {
  const location = useLocation()
  
  // Routes where we don't want to show the header/navbar
  const noHeaderRoutes = [
    '/create-event/form',
    '/create-event-2',
    '/create-event-3',
    '/create-event-4',
    '/admin/dashboard',
    '/user/dashboard',
  ]
  
  const shouldShowHeader =
    !noHeaderRoutes.includes(location.pathname) &&
    !location.pathname.startsWith('/qr-studio') &&
    !location.pathname.startsWith('/instapoints') &&
    !location.pathname.startsWith('/organizer') &&
    !location.pathname.startsWith('/app/') &&
    location.pathname !== '/door' &&
    !location.pathname.startsWith('/creators') &&
    !location.pathname.startsWith('/r/') &&
    location.pathname !== '/admin/creators'
  // Hide legacy Footer2 on marketplace routes — page includes MarketplaceNewUIFooter instead.
  const hideLegacyFooter =
    ['/', '/marketplace-home', '/merch', '/events', '/tickets', '/my-tickets', '/create-event', '/user/profile', '/admin/dashboard', '/user/dashboard', '/checkout'].includes(
      location.pathname
    ) ||
    location.pathname.startsWith('/qr-studio') ||
    location.pathname.startsWith('/organizer') ||
    location.pathname === '/door' ||
    location.pathname.startsWith('/event/') ||
    location.pathname.startsWith('/tickets/') ||
    location.pathname.includes('/group.details/')
  
  return (
    <InstaPassAIChatProvider>
      <ProfileSidebarProvider>
        {shouldShowHeader && <Navebar />}
        {children}
        {shouldShowHeader && !hideLegacyFooter && <Footer />}
        {shouldShowHeader && <InstaPassAIFloatingChat />}
      </ProfileSidebarProvider>
    </InstaPassAIChatProvider>
  )
}

export default LayoutIndex
